import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const linkClass = (path: string) =>
    `whitespace-nowrap text-sm font-medium transition-colors duration-200 ${
      location.pathname === path
        ? 'text-primary-600'
        : 'text-foreground-700 hover:text-primary-500'
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-flower-line text-primary-500 text-2xl"></i>
            </div>
            <span className="font-heading text-xl text-foreground-900 whitespace-nowrap">樱花动漫</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass('/')}>首页</Link>
            <Link to="/category/rexue" className={linkClass('/category/rexue')}>分类</Link>
            <Link to="/about" className={linkClass('/about')}>关于我们</Link>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className={linkClass('/')}>首页</Link>
          <Link to="/category/rexue" className={linkClass('/category/rexue')}>分类浏览</Link>
          <Link to="/about" className={linkClass('/about')}>关于我们</Link>
        </div>
      )}
    </nav>
  );
}